"use client";
import Input from "@/components/form/input/InputField";
import Label from "@/components/form/Label";
import Button from "@/components/ui/button/Button";
import { ChevronLeftIcon, EyeCloseIcon, EyeIcon } from "@/icons";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { api, handleApiError } from "@/lib/api";

export default function SignInForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const router = useRouter();
  
  useEffect(() => {
    const themeKey = "rmc_theme";
    const savedTheme = window.localStorage.getItem(themeKey);
    if (!savedTheme) {
      window.localStorage.setItem(themeKey, "dark");
      document.documentElement.classList.add("dark");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/api/v1/token/", {
        username,
        password,
      });
      const token = data?.access;
      if (!token) throw new Error("Missing access token");
      localStorage.setItem("access_token", token);
      localStorage.setItem("user", JSON.stringify({ username }));
      router.replace("/");
    } catch (err) {
      setError(handleApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col flex-1 lg:w-1/2 w-full">
      <div className="w-full max-w-sm sm:pt-10 mx-auto mb-4">
        {/* <Link
          href="/"
          className="inline-flex items-center text-xs text-gray-500 transition-colors hover:text-gray-200"
        >
          <ChevronLeftIcon className="size-4" />
          Back to dashboard
        </Link> */}
      </div>
      <div className="flex flex-col justify-center flex-1 w-full max-w-sm mx-auto">
        <div>
          <div className="mb-6 sm:mb-8 text-center sm:text-left">
            <h1 className="mb-1 font-bold text-white text-xl sm:text-2xl">
              Sign In
            </h1>
            <p className="text-xs text-gray-500">
              Enter your email and password to sign in!
            </p>
          </div>
          {error && <p className="text-red-500 text-xs mb-4">{error}</p>}
          <form onSubmit={handleSubmit}>
              <div className="space-y-4">
                <div>
                  <Label>
                    Username <span className="text-error-500">*</span>
                  </Label>
                  <Input
                    placeholder="Enter your username"
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <Label>
                    Password <span className="text-error-500">*</span>
                  </Label>
                  <div className="relative">
                    <Input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute z-30 -translate-y-1/2 cursor-pointer right-3 top-1/2"
                    >
                      {showPassword ? (
                        <EyeIcon className="fill-gray-500 hover:fill-gray-300 transition-colors size-4" />
                      ) : (
                        <EyeCloseIcon className="fill-gray-500 hover:fill-gray-300 transition-colors size-4" />
                      )}
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between">

                </div>
                <div className="pt-2">
                  <Button type="submit" className="w-full" size="md" disabled={loading}>
                    {loading ? "Signing in..." : "Sign in"}
                  </Button>
                </div>
              </div>
            </form>
        </div>
      </div>
    </div>
  );
}
